<template>
  <ks-overlay :ref="`fileViewerModal${_uid}`" position="left">
    <div class="file-viewer-modal-container">
      <ks-file-viewer
        :ref="`fileViewer${_uid}`"
        :viewType="viewType"
        :width="width"
        :height="height"
        :files="localFiles"
        :defaultFilters="defaultFilters"
        :defaultFileIndex="defaultFileIndex"
      />
    </div>
  </ks-overlay>
</template>

<script>
  export default {
    /**
        tag
        name: ks-file-viewer-modal
        description: file viewer 
    **/
    name: 'ks-file-viewer-modal',
    props: {
      viewType: {
        type: String,
        default: 'content', //thumbnail-upload
      },
      modalTitle: {
        type: String,
        default: null,
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: String,
        default: '100%',
      },
      files: {
        type: Array,
        default: () => [],
      },
      defaultFilters: {
        type: Object,
        default: null,
      },
      defaultFileIndex: {
        type: Number,
        default: 0,
      },
    },
    watch: {
      files: {
        handler(val) {
          this.localFiles = val;
        },
        deep: true,
      },
    },
    methods: {
      open(fileIndex = null, files = []) {
        if (files) this.localFiles = files;
        if (fileIndex !== null) {
          this.$refs[`fileViewer${this._uid}`].setCurrentIndex(fileIndex);
        }
        this.$refs[`fileViewerModal${this._uid}`].open();
      },
      close() {
        this.$refs[`fileViewerModal${this._uid}`].close();
      },
    },
    data() {
      return {
        localFiles: this.files,
      };
    },
  };
</script>

<style scoped>
  .file-viewer-modal-container {
    padding-top: 60px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000000c2;
  }
</style>
